"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnemySpawnerComponent = void 0;
require("core-js/modules/es.weak-map.js");
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _eventBusComponent = require("../events/event-bus-component");
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _scene = /*#__PURE__*/new WeakMap();
var _spawnInterval = /*#__PURE__*/new WeakMap();
var _spawnAt = /*#__PURE__*/new WeakMap();
var _group = /*#__PURE__*/new WeakMap();
var _disableSpawning = /*#__PURE__*/new WeakMap();
class EnemySpawnerComponent {
  constructor(scene, enemyClass, spawnConfig, eventBusComponent) {
    _classPrivateFieldInitSpec(this, _scene, void 0);
    _classPrivateFieldInitSpec(this, _spawnInterval, void 0);
    _classPrivateFieldInitSpec(this, _spawnAt, void 0);
    _classPrivateFieldInitSpec(this, _group, void 0);
    _classPrivateFieldInitSpec(this, _disableSpawning, void 0);
    _classPrivateFieldSet(_scene, this, scene);
    _classPrivateFieldSet(_group, this, _classPrivateFieldGet(_scene, this).add.group({
      name: "".concat(this.constructor.name, "-").concat(Phaser.Math.RND.uuid()),
      classType: enemyClass,
      runChildUpdate: true,
      createCallback: enemy => {
        enemy.init(eventBusComponent);
      }
    }));
    _classPrivateFieldSet(_spawnInterval, this, spawnConfig.interval);
    _classPrivateFieldSet(_spawnAt, this, spawnConfig.spawnAt);
    _classPrivateFieldSet(_disableSpawning, this, false);
    _classPrivateFieldGet(_scene, this).events.on(Phaser.Scenes.Events.UPDATE, this.update, this);
    _classPrivateFieldGet(_scene, this).physics.world.on(Phaser.Physics.Arcade.Events.WORLD_STEP, this.worldStep, this);
    _classPrivateFieldGet(_scene, this).events.once(Phaser.Scenes.Events.DESTROY, () => {
      _classPrivateFieldGet(_scene, this).events.off(Phaser.Scenes.Events.UPDATE, this.update, this);
      _classPrivateFieldGet(_scene, this).physics.world.off(Phaser.Physics.Arcade.Events.WORLD_STEP, this.worldStep, this);
    }, this);
    eventBusComponent.on(_eventBusComponent.CUSTOM_EVENTS.GAME_OVER, () => {
      _classPrivateFieldSet(_disableSpawning, this, true);
    });
  }
  get phaserGroup() {
    return _classPrivateFieldGet(_group, this);
  }
  update(ts, dt) {
    if (_classPrivateFieldGet(_disableSpawning, this)) return;
    _classPrivateFieldSet(_spawnAt, this, _classPrivateFieldGet(_spawnAt, this) - dt);
    if (_classPrivateFieldGet(_spawnAt, this) > 0) return;
    const x = Phaser.Math.RND.between(30, _classPrivateFieldGet(_scene, this).scale.width - 30);
    const enemy = _classPrivateFieldGet(_group, this).get(x, -20);
    enemy.reset();
    _classPrivateFieldSet(_spawnAt, this, _classPrivateFieldGet(_spawnInterval, this));
  }
  worldStep(delta) {
    _classPrivateFieldGet(_group, this).getChildren().forEach(enemy => {
      if (!enemy.active) return;
      if (enemy.y > _classPrivateFieldGet(_scene, this).scale.height + 50) {
        enemy.setActive(false);
        enemy.setVisible(false);
      }
    });
  }
}
exports.EnemySpawnerComponent = EnemySpawnerComponent;